<template>
  <div class="container-main">
    <bannerVideo bg="#949590" videoUrl="" allVideoUrl="" :bgImage="bannerImage" title="STEAM" message="多种素质课程，全面助力机构"></bannerVideo>
    <outboxCon bg="#F8F9FD">
        <div class="my-production">
          <header>我们的产品</header>
          <div class="content">
            <img :src="myProductionImg" alt="">
          </div>
        </div>
    </outboxCon>
    <outboxCon bg="#fff">
        <div class="choice-me">
          <header>为什么选择我们</header>
          <div class="content">
            <img :src="choiceMe" alt="">
          </div>
        </div>
    </outboxCon>
    <outboxCon bg="#F8F9FD">
        <div class="my-content">
          <header>我们的内容</header>
          <ul>
            <li v-for="item in myContentList" :key="item.title">
              <img :src="item.image" alt="" />
              <p>
                <h6>{{ item.title }}</h6>
                <span>{{ item.content }}</span>
              </p>
            </li>
            <!--手动添加两个空dom 用来匹配flex样式-->
            <li></li>
            <li></li>
          </ul>
        </div>
    </outboxCon>
  </div>
</template>
<script>
import bannerVideo from './components/bannerVideo/bannerVideo'
export default {
  data () {
    return {
      myProductionImg: require('@/assets/coursetype/suyang/my-production.png'),
      choiceMe: require('@/assets/coursetype/suyang/choice-me.png'),
      myContentList: [
        {
          image: require('@/assets/coursetype/suyang/content-1.png'),
          title: 'STEAM',
          content: '以STEAM模式代替传统教学，助力孩子主动探索和独立思考'
        },
        {
          image: require('@/assets/coursetype/suyang/content-2.png'),
          title: '分级阅读',
          content: '文学、科幻、侦探…多主题相互交叉融合，帮助孩子多角度认识更广阔的的世界'
        },
        {
          image: require('@/assets/coursetype/suyang/content-3.png'),
          title: '数独',
          content: '逻辑推理、思考力、专注力、洞察力、反应力、记忆力，六大能力全覆盖'
        },
        {
          image: require('@/assets/coursetype/suyang/content-4.png'),
          title: '写字课',
          content: '科学设计，循序渐进，实用与审美相辅'
        },
        {
          image: require('@/assets/coursetype/suyang/content-5.png'),
          title: '美术课',
          content: '学习美术基础知识，培养创意设计，激发好奇心和想象力，初步进行平面和立体构建'
        },
        {
          image: require('@/assets/coursetype/suyang/content-6.png'),
          title: '无人机',
          content: '趣味性飞行课程安排，分阶段操控联系，锻炼孩子的手、脑、眼并用能力'
        },
        {
          image: require('@/assets/coursetype/suyang/content-7.png'),
          title: '编程',
          content: '通过Scratch、Python等图形化编程工具学习，寓教于乐，锻炼孩子逻辑思维'
        },
        {
          image: require('@/assets/coursetype/suyang/content-8.png'),
          title: '研学',
          content: '已麦斯的太空之旅为线索，涵盖三大视野拓展课程，三大宇宙探索工具和三大嘉年华趣味活动'
        }
      ],
      bannerImage: require('@/assets/coursetype/suyang/banner.png')
    }
  },
  components: { bannerVideo },
  mounted() {
    document.documentElement.scrollTo(0,0)
  }
}
</script>

<style lang="scss" scoped>
.my-production,
.choice-me,
.my-content {
  width: $main-width;
  margin: 0 auto;
  padding: 50px 0px 95px 0px;
  position: relative;
  header {
    height: 56px;
    font-size: 40px;
    font-weight: 500;
    color: #282828;
    line-height: 56px;
  }
  .content {
    img {
      width: 1280px;
    }
  }
}

.my-content {
  ul {
    padding-top: 46px;
    padding-inline-start: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      padding-top: 70px;
      width: 400px;
      img {
        width: 400px;
      }
      h6 {
        padding-top: 38px;
        font-size: 24px;
        font-weight: 600;
        color: #282828;
        text-align: left;
      }
      span {
        display: inline-block;
        vertical-align: top;
        text-align: left;
        line-height: 34px;
      }
    }
  }
}
</style>
